import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Spinner,
} from '@customerio/pluma-components/react';

export function CollectionImportingState() {
  return (
    <EmptyState>
      <EmptyStateGraphic>
        <Spinner />
      </EmptyStateGraphic>
      <EmptyStateTitle>Importing…</EmptyStateTitle>
      <EmptyStateDescription>
        We're importing your file, which may take a few minutes. Feel free to leave this page until it's done.
      </EmptyStateDescription>
    </EmptyState>
  );
}
